/* ==========================================================================
   C-Subscription-Page — Shared JavaScript
   Handles: option selection, cart AJAX, sticky bar, FAQ accordion, gallery
   ========================================================================== */

(function () {
  'use strict';

  /* ── State ── */
  let currentOption = null;

  /* ── Option Selection ── */

  function initOptionSelection() {
    const options = document.querySelectorAll('[data-c-option]');
    if (!options.length) return;

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        selectOption(opt.dataset.cOption);
      });
    });

    // Select default option
    var defaultOpt = document.querySelector('[data-c-option][data-c-default="true"]');
    if (defaultOpt) {
      selectOption(defaultOpt.dataset.cOption);
    }
  }

  function selectOption(key) {
    currentOption = key;
    var options = document.querySelectorAll('[data-c-option]');

    options.forEach(function (opt) {
      var isActive = opt.dataset.cOption === key;
      opt.classList.toggle('c-option--active', isActive);
      opt.classList.toggle('c-option--inactive', !isActive);

      // Radio SVG visibility is handled by CSS via .c-option--active class

      // Toggle perks visibility for hero card
      var perks = opt.querySelector('.c-hero-opt__perks');
      if (perks) {
        perks.style.display = isActive ? '' : 'none';
      }
    });

    // Update hidden form inputs (variant + selling plan)
    var activeOpt = document.querySelector('[data-c-option="' + key + '"]');
    if (activeOpt) {
      var variantInput = document.getElementById('c-variant-id');
      if (variantInput && activeOpt.dataset.cVariant) {
        variantInput.value = activeOpt.dataset.cVariant;
      }
      var sellingPlanInput = document.getElementById('c-selling-plan');
      if (sellingPlanInput) {
        sellingPlanInput.value = activeOpt.dataset.cSellingPlan || '';
      }
    }

    // Update CTA button text
    var ctaText = activeOpt ? activeOpt.dataset.cCtaText : '';
    var ctaBtn = document.getElementById('c-cta-btn');
    if (ctaBtn && ctaText) {
      ctaBtn.textContent = ctaText;
    }

    // Dispatch event for sticky bar and other listeners
    document.dispatchEvent(new CustomEvent('c:option-change', {
      detail: {
        key: key,
        ctaText: ctaText,
        stickyText: activeOpt ? activeOpt.dataset.cStickyText : '',
        sellingPlan: activeOpt ? activeOpt.dataset.cSellingPlan : ''
      }
    }));
  }

  /* ── Cart AJAX ── */

  function initCartSubmit() {
    var form = document.getElementById('c-product-form');
    if (!form) return;
    var isSubmitting = false;

    function handleSubmit(e) {
      e.preventDefault();
      if (isSubmitting) return;
      isSubmitting = true;

      addToCart(form, function () { isSubmitting = false; });
    }

    // Handle form submit (from CTA button with form= attribute)
    form.addEventListener('submit', handleSubmit);

    // Handle clicks on external submit buttons (sticky bar)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[form="c-product-form"]');
      if (btn && btn.type === 'submit') {
        handleSubmit(e);
      }
    });
  }

  function addToCart(formEl, onComplete) {
    var btn = document.getElementById('c-cta-btn');
    var stickyBtn = document.getElementById('c-sticky-cta');
    var originalText = btn ? btn.textContent : '';

    // Disable buttons during request
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    if (stickyBtn) { stickyBtn.disabled = true; }

    var formData = new FormData(formEl);

    // Get cart drawer section IDs for section rendering
    var cartDrawer = document.querySelector('cart-drawer-component');
    var cartItems = document.querySelector('cart-items-component');
    var sectionsToFetch = [];
    if (cartItems && cartItems.dataset.sectionId) {
      sectionsToFetch.push(cartItems.dataset.sectionId);
    }

    // Add sections param for section rendering API
    if (sectionsToFetch.length) {
      formData.append('sections', sectionsToFetch.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Add to cart failed');
          });
        }
        return response.json();
      })
      .then(function (data) {
        // Dispatch cart:update event so cart drawer + cart icon update
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'c-product-form',
            data: {
              source: 'c-product-form',
              itemCount: data.item_count || null,
              sections: data.sections || {},
              variantId: formData.get('id')
            }
          }
        }));

        // Open cart drawer
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        // Reset button text after delay
        setTimeout(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
          if (stickyBtn) { stickyBtn.disabled = false; }
          if (onComplete) onComplete();
        }, 2000);
      })
      .catch(function (err) {
        console.error('C add to cart error:', err);
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
        if (stickyBtn) { stickyBtn.disabled = false; }
        if (onComplete) onComplete();
      });
  }

  /* ── Sticky Bar ── */

  function initStickyBar() {
    var hero = document.querySelector('[data-c-hero]');
    var sticky = document.querySelector('[data-c-sticky]');
    if (!hero || !sticky) return;

    var heroPassed = false;
    var footerVisible = false;

    function updateSticky() {
      sticky.classList.toggle('c-sticky--visible', heroPassed && !footerVisible);
    }

    // Show after hero scrolls out of view
    new IntersectionObserver(function (entries) {
      heroPassed = !entries[0].isIntersecting;
      updateSticky();
    }, { threshold: 0 }).observe(hero);

    // Hide when any footer comes into view (C-footer or theme footer)
    var footers = document.querySelectorAll('footer, .footer, [role="contentinfo"]');
    if (footers.length) {
      var footerObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries.some(function (e) { return e.isIntersecting; });
        updateSticky();
      }, { threshold: 0 });
      footers.forEach(function (f) { footerObserver.observe(f); });
    }

    // Update sticky text when option changes
    var stickySubEl = document.getElementById('c-sticky-sub');
    document.addEventListener('c:option-change', function (e) {
      if (stickySubEl && e.detail.stickyText) {
        stickySubEl.textContent = e.detail.stickyText;
      }
    });

    // Sync sticky text with the already-selected default option
    var activeOpt = document.querySelector('[data-c-option].c-option--active');
    if (stickySubEl && activeOpt && activeOpt.dataset.cStickyText) {
      stickySubEl.textContent = activeOpt.dataset.cStickyText;
    }
  }

  /* ── FAQ Accordion ── */

  function initFaqAccordion() {
    document.addEventListener('click', function (e) {
      var question = e.target.closest('.c-faq-question');
      if (!question) return;

      var item = question.closest('.c-faq-item');
      if (!item) return;

      var answer = item.querySelector('.c-faq-answer');
      if (!answer) return;

      var isOpen = item.classList.contains('c-faq-item--open');

      if (isOpen) {
        // Close: capture current height, remove class, animate to 0
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.offsetHeight; // force reflow
        item.classList.remove('c-faq-item--open');
        answer.style.maxHeight = '0';
      } else {
        // Open: add class, measure full height including padding, animate
        item.classList.add('c-faq-item--open');
        var fullHeight = answer.scrollHeight + 19; // account for padding-bottom
        answer.style.maxHeight = fullHeight + 'px';

        // Remove max-height after transition to allow dynamic content
        answer.addEventListener('transitionend', function handler(e) {
          if (e.propertyName !== 'max-height') return;
          if (item.classList.contains('c-faq-item--open')) {
            answer.style.maxHeight = 'none';
          }
          answer.removeEventListener('transitionend', handler);
        });
      }
    });
  }

  /* ── Thumbnail Gallery ── */

  function initGallery() {
    var container = document.querySelector('[data-c-gallery]');
    if (!container) return;

    var mainImg = container.querySelector('[data-c-main-image]');
    var thumbs = container.querySelectorAll('[data-c-thumb]');
    if (!mainImg || !thumbs.length) return;

    var currentIndex = 0;

    function goToImage(index) {
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentIndex = index;

      var thumb = thumbs[index];
      var src = thumb.dataset.cThumbSrc;
      var srcset = thumb.dataset.cThumbSrcset;
      var alt = thumb.dataset.cThumbAlt || '';

      if (src) mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      mainImg.alt = alt;

      thumbs.forEach(function (t) { t.classList.remove('c-thumb--active'); });
      thumb.classList.add('c-thumb--active');
    }

    // Thumbnail click
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goToImage(i);
      });
    });

    // Swipe on main image
    var touchStartX = 0;
    var touchEndX = 0;
    var minSwipe = 50;

    var isSwiping = false;

    mainImg.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      isSwiping = false;
    }, { passive: true });

    mainImg.addEventListener('touchmove', function (e) {
      var diffX = Math.abs(e.changedTouches[0].screenX - touchStartX);
      if (diffX > 10) {
        isSwiping = true;
        e.preventDefault(); // prevent page drag during horizontal swipe
      }
    }, { passive: false });

    mainImg.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (isSwiping && Math.abs(diff) > minSwipe) {
        if (diff > 0) {
          goToImage(currentIndex + 1);
        } else {
          goToImage(currentIndex - 1);
        }
      }
    }, { passive: true });

    // Prevent image drag on desktop
    mainImg.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ── Init ── */

  function init() {
    initOptionSelection();
    initCartSubmit();
    initStickyBar();
    initFaqAccordion();
    initGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
